@if (!isPdfRoute && !isAuthErrorRoute) {
  <nz-layout class="general-container" style="position: relative;">
    <app-sidebar [isDetailRoute]="isDetailRoute"></app-sidebar>

    <nz-layout>
      <nz-content>
        <main [class.isDetailRoute]="isDetailRoute">
          <router-outlet></router-outlet>
        </main>
      </nz-content>
    </nz-layout>

    @if (!(oidcSecurityService.isAuthenticated() | async)) {
      <div class="not-auth"></div>
    }
  </nz-layout>

}

@if (isPdfRoute || isAuthErrorRoute) {
  <router-outlet></router-outlet>
}
